import { Inject } from '@angular/core';
import '@angular/compiler';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageAdminSubjectsComponent } from './page.admin.subjects/page.admin.subjects.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageSurveyInvalidComponent } from './page.survey.invalid/page.survey.invalid.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PageAdminFormsItemComponent } from './page.admin.forms.item/page.admin.forms.item.component';
import { ComponentSurveyRendererComponent } from './component.survey.renderer/component.survey.renderer.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageSurveyDoneComponent } from './page.survey.done/page.survey.done.component';
import { PageAdminStatisticsComponent } from './page.admin.statistics/page.admin.statistics.component';
import { PageSurveyTakeComponent } from './page.survey.take/page.survey.take.component';
import { PageAdminResultsItemComponent } from './page.admin.results.item/page.admin.results.item.component';
import { PageAdminSubjectsItemComponent } from './page.admin.subjects.item/page.admin.subjects.item.component';
import { PageAdminResultsComponent } from './page.admin.results/page.admin.results.component';
import { PageAdminDashboardComponent } from './page.admin.dashboard/page.admin.dashboard.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { LayoutSurveyComponent } from './layout.survey/layout.survey.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PageLoginComponent,
        PortalSeasonLoadingDefaultComponent,
        PageAdminSubjectsComponent,
        PortalSeasonTreeComponent,
        PageSurveyInvalidComponent,
        LayoutAdminComponent,
        LayoutEmptyComponent,
        PageAdminFormsItemComponent,
        ComponentSurveyRendererComponent,
        PortalSeasonPaginationComponent,
        PageSurveyDoneComponent,
        PageAdminStatisticsComponent,
        PageSurveyTakeComponent,
        PageAdminResultsItemComponent,
        PageAdminSubjectsItemComponent,
        PageAdminResultsComponent,
        PageAdminDashboardComponent,
        PortalSeasonFormDropdownComponent,
        LayoutSurveyComponent,
        PortalSeasonLoadingSeasonComponent,
        PortalSeasonModalComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }